/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { healthControllerHealthCheck } from '../fn/health/health-controller-health-check';
import { HealthControllerHealthCheck$Params } from '../fn/health/health-controller-health-check';

@Injectable({ providedIn: 'root' })
export class HealthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `healthControllerHealthCheck()` */
  static readonly HealthControllerHealthCheckPath = '/api/health';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healthControllerHealthCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthControllerHealthCheck$Response(params?: HealthControllerHealthCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return healthControllerHealthCheck(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `healthControllerHealthCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthControllerHealthCheck(params?: HealthControllerHealthCheck$Params, context?: HttpContext): Observable<void> {
    return this.healthControllerHealthCheck$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
